export class ExternalInteractorBase {
    constructor(container) {
        this.container = container;
        this.type = 0;
    }
}
